import { parsePhoneNumberFromString } from 'libphonenumber-js';

export function normalizePhoneNumber(value: string): string | null {
  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }

  const phone = parsePhoneNumberFromString(trimmed, trimmed.startsWith('+') ? undefined : 'US');
  if (!phone?.isValid()) {
    return null;
  }

  return phone.number;
}
